const promises = [
  ['01', 'Structured learning', 'Know what to learn next, and why it matters.'],
  [
    '02',
    'Curated problems',
    'Practice the ideas that will move your skills forward.'
  ],
  [
    '03',
    'Personalized practice',
    'Build confidence at a pace that works for you.'
  ]
]

export function PromiseSection() {
  return (
    <section className="promise" aria-label="What ihatecp is building">
      <p className="eyebrow">BUILT TO MAKE PROGRESS FEEL POSSIBLE</p>
      <div className="promise-grid">
        {promises.map(([number, title, description]) => (
          <article key={number}>
            <span>{number}</span>
            <h2>{title}</h2>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
